import { render, staticRenderFns } from "./link-col.vue?vue&type=template&id=0db9b7d6&"
import script from "./link-col.vue?vue&type=script&lang=js&"
export * from "./link-col.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports